import * as React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const tooltipColor = '#E1E0E1'
export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: tooltipColor,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: tooltipColor,
    color: '#444444',
    fontSize: 12,
    padding: '8px 12px',
  },
}))
